import { render, staticRenderFns } from "./te-select-card.vue?vue&type=template&id=2ff5062c"
import script from "./te-select-card.vue?vue&type=script&lang=js"
export * from "./te-select-card.vue?vue&type=script&lang=js"
import style0 from "./te-select-card.vue?vue&type=style&index=0&id=2ff5062c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports